// Photo URL → base64 helper for client-side rerun of identify-appliance v10.
// v10 accepts base64 only (not URLs), so the guided documentation flow needs
// to download each existing photo and encode it before invoking the function.

export async function fetchPhotoAsBase64(url) {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`fetch ${url} failed: ${res.status}`)
  const buf = await res.arrayBuffer()
  const bytes = new Uint8Array(buf)
  // Chunked toString to avoid stack blowups on larger photos.
  let binary = ''
  const chunk = 0x8000
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk))
  }
  const base64 = btoa(binary)
  const mediaType = res.headers.get('content-type') || 'image/jpeg'
  return { base64, mediaType }
}
